import { IFetchListRequestPayload } from '@interfaces/common';
import {
  ICreateNewSupplementResponse,
  IDietarySupplementDetails,
  IDietarySupplementSearchResult,
  ISubmitSupplementNeedsInfoFormPayload,
  ISupplementResponseDetails,
  IUserEnteredSupplement,
  IUserEnteredSupplementData,
  IUserSupplementImageSettings,
} from '@interfaces/supplements';

import { apiUrls } from './urls';
import { get, post, postFormWithFiles, put, putFormWithFiles } from './utils';

export const createNewSupplement = (payload: IUserEnteredSupplementData) =>
  postFormWithFiles<ICreateNewSupplementResponse>(apiUrls.userEnteredSupplements.create, payload);

export const editUserEnteredSupplement = (payload: IUserEnteredSupplement) =>
  putFormWithFiles(apiUrls.userEnteredSupplements.update, payload);

export const getSupplementResponseDetails = (supplementId: number) =>
  get<ISupplementResponseDetails>(`${apiUrls.inquiries.responseDetails}/${supplementId}`);

export const markSupplementResponseAsViewed = (supplementId: number) =>
  post(`${apiUrls.inquiries.supplementViewed}/${supplementId}`);

export const submitSupplementNeedsInfoForm = (payload: ISubmitSupplementNeedsInfoFormPayload) =>
  postFormWithFiles(apiUrls.userEnteredSupplements.addNote, payload);

export const searchSupplements = (payload: IFetchListRequestPayload) =>
  post<IDietarySupplementSearchResult>(apiUrls.supplements.search, payload);

export const getSupplementDetails = (id: number) =>
  get<IDietarySupplementDetails>(`${apiUrls.supplements.details}/${id}`);

export const getUserEnteredSupplementDetails = (id: number) =>
  get<IUserEnteredSupplement>(`${apiUrls.userEnteredSupplements.details}/${id}`);

export const getUserSupplementSettings = () =>
  get<IUserSupplementImageSettings>(`${apiUrls.userEnteredSupplements.settings}`);
